import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ToastrModule } from 'ngx-toastr';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';


import { AuthService } from './shared/services/authService/auth.service';
import { AuthInterceptorService } from './shared/services/interceptor/auth-interceptor.service';
import { LoaderService } from './shared/services/interceptor/loader.service';
import { AuthRemoteService } from './shared/services/authService/auth-remote.service';
import { AdminGuard } from './shared/guard/admin.guard';
import { SecureAuthPagesGuard } from './shared/guard/secure-auth-pages.guard';
import { SuperAdminCreated } from './shared/guard/SuperAdminCreated.guard';
import { SecureInnerPagesGuard } from './shared/guard/SecureInnerPagesGuard.guard';
import { CookieService } from 'ngx-cookie-service';
import {MatTableResponsiveModule} from './shared/mat-table-responsive/mat-table-responsive.module';
import {MatTableModule} from '@angular/material/table';
// import { AngularFireModule } from "@angular/fire";
// import { AngularFireAuthModule } from "@angular/fire/auth";

import {ButtonModule} from 'primeng/button';
import {SidebarModule} from 'primeng/sidebar';

// import { environment } from '../environments/environment';
// import { AngularFirestoreModule } from '@angular/fire/firestore';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { NgSelectModule } from '@ng-select/ng-select';

export function createTranslateLoader(httpClient: HttpClient){
  return new TranslateHttpLoader(httpClient, './assets/i18n/','.json');
}
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory:(createTranslateLoader),// useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFireAuthModule,
    // AngularFirestoreModule,
    MDBBootstrapModule.forRoot(),
    NgSelectModule,
    MatTableModule,
    ButtonModule,
    SidebarModule,
    MatTableResponsiveModule
  ],
  providers: [AuthService, AdminGuard, SuperAdminCreated,
    SecureInnerPagesGuard, SecureAuthPagesGuard,
    CookieService,AuthRemoteService, LoaderService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
